import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
// 业务页面
import FourDay from "./views/FourDay.vue";
import ShuQi from "./views/ShuQi.vue";
import ZhongYi from "./views/ZhongYi.vue";


Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/fourday",
      name: "fourday",
      component: FourDay
    },
    {
      path: "/shuqi",
      name: "shuqi",
      component:ShuQi
    },
    {
      path: "/zhongyi",
      name: "zhongyi",
      component: ZhongYi
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import( /* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/dingxiang",
      name: "dingxiang",
      component: () =>
        import("./views/DingXiang.vue")
    },
    {
      path: "/chunji",
      name: "chunji",
      component: () =>
        import("./views/ChunJi.vue")
    },
    {
      path: "/dongji",
      name: "dongji",
      component: () =>
        import("./views/DongJi.vue")
    },
    {
      path: "/mingshi",
      name: "mingshi",
      component: () =>
        import("./views/MingShi.vue")
    },
    {
      path: "/xueyuan",
      name: "xueyuan",
      component: () =>
        import("./views/XueYuan.vue")
    },
    {
      path: "/kaiying",
      name: "kaiying",
      component: () =>
        import("./views/KaiYing.vue")
    },
    {
      path: "/jidi",
      name: "jidi",
      component: () =>
        import("./views/JiDi.vue")
    },
    {
      path: "/pinpai",
      name: "pinpai",
      component: () =>
        import("./views/PinPai.vue")
    },
    {
      path: "/duanwu",
      name: "duanwu",
      component: () =>
        import("./views/DuanWu.vue")
    },
    {
      path: "/chongci",
      name: "chongci",
      component: () =>
        import("./views/ChongCi.vue")
    },
  ]
});